import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { AmexCard } from '@pets-ui/icons'
import { type JSX } from 'react'
import JCBIcon from '../assets/icon-card-jcb.svg?react'
import MasterCardIcon from '../assets/icon-card-master.svg?react'
import VisaCardIcon from '../assets/icon-card-visa.svg?react'

export type CreditCardOrganization = 'visa' | 'master' | 'jcb' | 'american express'
export interface CreditCardOrganizationIconsProps {
  organization?: CreditCardOrganization
  supportedOrganizations?: CreditCardOrganization[]
}
const creditCardIconsMap: Record<CreditCardOrganization, JSX.Element> = {
  'visa': <VisaCardIcon />,
  'master': <MasterCardIcon />,
  'jcb': <JCBIcon />,
  'american express': <AmexCard />,
}
export const CreditCardOrganizationIcons = (props: CreditCardOrganizationIconsProps) => {
  const { organization, supportedOrganizations } = props

  const renderIcons = () => {
    if (organization && organization in creditCardIconsMap) {
      return creditCardIconsMap[organization]
    }
    if (supportedOrganizations) {
      return supportedOrganizations
        .filter(org => org in creditCardIconsMap)
        .map(org => (
          <Box key={org}>
            {creditCardIconsMap[org]}
          </Box>
        ),
        )
    }
    return null
  }

  return (
    <HStack gap={1} alignItems="center">
      {renderIcons()}
    </HStack>
  )
}
